// Hand-written API client wrapper over the generated `openapi.ts` types.
// DO NOT regenerate or overwrite this file — only `openapi.ts` is generated.
import { Fetcher } from 'openapi-typescript-fetch';
export function createApiClient(options) {
    const fetcher = Fetcher.for();
    const headers = { ...options.headers };
    fetcher.configure({
        baseUrl: options.baseUrl,
        init: { headers },
        use: [
            async (url, init, next) => {
                const nextHeaders = new Headers(init?.headers || {});
                const token = options.tokenStorage.getAccessToken();
                if (token) {
                    nextHeaders.set('Authorization', `Bearer ${token}`);
                }
                return next(url, { ...init, headers: nextHeaders });
            }
        ]
    });
    const call = async (method, path, args, queryKeys) => {
        const create = fetcher.path(path).method(method).create;
        try {
            const result = await create(queryKeys)(args);
            return result.data;
        }
        catch (err) {
            // Throw exactly what the API returned
            throw err.data;
        }
    };
    return {
        raw: fetcher,
        get(path, args, queryKeys) {
            return call('get', path, args, queryKeys);
        },
        post(path, args, queryKeys) {
            return call('post', path, args, queryKeys);
        },
        put(path, args, queryKeys) {
            return call('put', path, args, queryKeys);
        },
        patch(path, args, queryKeys) {
            return call('patch', path, args, queryKeys);
        },
        delete(path, args, queryKeys) {
            return call('delete', path, args, queryKeys);
        }
    };
}
